import {
  convertQuarterlyReports,
  QuarterlyReportsParams,
  QuarterlyReportsResponse,
} from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export function useQuarterlyReports(props: QuarterlyReportsParams) {
  const { server } = useServer()
  return useQuery({
    queryKey: keys.quarterlyReports(props),
    queryFn: getQuarterlyReports,
    enabled: !!props.companyId,
    retry: false,
  })
  async function getQuarterlyReports() {
    const queryParams = new URLSearchParams()
    queryParams.set('quarter', props.quarter.toString())
    queryParams.set('year', props.year.toString())
    queryParams.set('team_insights_report', props.teamInsightsReport.toString())
    queryParams.set(
      'store_insights_report',
      props.storeInsightsReport.toString()
    )

    const url = `v2/managers/reports/${
      props.companyId
    }?${queryParams.toString()}`

    const response =
      await server.get<QuarterlyReportsResponse.QuarterlyReports>(url)
    return convertQuarterlyReports(response)
  }
}
